<script setup lang="ts">
import { getImageUrl } from "~/common/helpers/get-image-url";

interface Tooltip {
	title: string | number;
	description: string | number;
	imageId: number;
	placement: string;
}

/** @todo temporary solution to prevent hydration mismatch issue */
const ariaId = useId();

defineProps({
	tooltip: {
		type: Object as PropType<Tooltip>,
		required: true
	}
});
</script>

<template>
	<VTooltip
		theme="collection-item"
		:triggers="['hover']"
		:placement="tooltip.placement"
		:distance="16"
		:delay="0"
		:aria-id="ariaId"
	>
		<button class="group w-10 h-10 flex items-center justify-center rounded-full bg-white/30">
			<div class="w-7 h-7 rounded-full bg-white group-hover:w-full group-hover:h-full duration-150">
				<span class="inline-block text-2xl align-middle translate-x-[2px] translate-y-[2px] group-hover:translate-x-0 group-hover:translate-y-[10px] duration-150">+</span>
			</div>
		</button>
		<template #popper>
			<article class="p-4">
				<NuxtImg
					:src="getImageUrl(tooltip.imageId, { width: 300, height: 400 })"
					:width="150"
					:height="200"
					alt="image"
				/>
				<div class="mt-4 text-sm max-w-[150px]">
					<div class="font-medium">
						{{ tooltip.title }}
					</div>
					<span>{{ tooltip.description }}</span>
				</div>
			</article>
		</template>
	</VTooltip>
</template>

<style>
.v-popper--theme-collection-item .v-popper__inner {
  background: #ffffff;
  color: #000000;
  border: none;
  border-radius: 0px;
  box-shadow: 0px 8px 15px 0px rgba(140, 152, 164, 0.1);
}
.v-popper--theme-collection-item .v-popper__arrow-outer {
  border-color: #ffffff;
}
.v-popper--theme-collection-item .v-popper__arrow-inner {
  visibility: hidden;
}
</style>
